import { PIN_COUNTER_MIN_COUNT } from './getPinCounterLabel';

import type { IPinPaginationProps } from './markups/pagination/getPaginationRenderer';
import type { IFeatureProperties } from '../../../types/map';

export function getPinPagination(
  { offers, offersCount }: IFeatureProperties,
  activeOfferRealtyId: number | null | undefined,
): IPinPaginationProps | null {
  if (
    activeOfferRealtyId == null ||
    (offersCount ?? 0) < PIN_COUNTER_MIN_COUNT ||
    offers.length < PIN_COUNTER_MIN_COUNT
  ) {
    return null;
  }

  const index = offers.findIndex(offer => offer.realtyId === activeOfferRealtyId);

  return index === -1 ? null : { current: index + 1, total: offers.length };
}
